import { apiSlice } from "../../app/api/apiSlice"
import { generateFormatedURL } from "../../utils/urlFormatter"

export const ScheduleSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getScheduleById: builder.query({
            query: (body) => ({
                url: `/project/${body?.projectId}/location/${body?.locationId}/WorkSchedule/${body?.id}`,
            }),
        }),

        getScheduleByScheduleId: builder.query({
            query: (body) => ({
                url: `/WorkSchedule/${body?.id}`,
            }),
        }),

        getScheduleListing: builder.query({
            query: (args) => `/WorkSchedule/list`.concat(generateFormatedURL(args)),
        }),

        createSchedule: builder.mutation<any, { projectId: string, locationId: string, formData: FormData }>({
            query: ({ projectId, locationId, formData }) => ({
                url: `/project/${projectId}/location/${locationId}/WorkSchedule`,
                method: 'POST',
                body: formData,
                formData: true
            })
        }),

        updateSchedule: builder.mutation<any, { projectId: string, locationId: string, id: string, formData: FormData }>({
            query: ({ projectId, locationId, id, formData }) => ({
                url: `/project/${projectId}/Location/${locationId}/WorkSchedule/${id}`,
                method: 'PUT',
                body: formData,
                formData: true
            })
        }),

        getTodaySchedule: builder.query({
            query: (args) => `/WorkSchedule/today`.concat(generateFormatedURL(args)),
        }),

        getWorkScheduleDetail: builder.query({
            query: (body) => ({
                url: `/project/${body?.projectId}/location/${body?.locationId}/WorkSchedule/${body?.id}`,
            }),
        }),

        workerCheckIn: builder.mutation<any, { workScheduleId: string, workerId: string, time: string }>({
            query: ({ workScheduleId, workerId, time }) => ({
                url: `/WorkSchedule/${workScheduleId}/Worker/${workerId}/CheckIn?time=${time}`,
                method: 'POST',
            })
        }),

        workerCheckOut: builder.mutation<any, { workScheduleId: string, workerId: string, time: string }>({
            query: ({ workScheduleId, workerId, time }) => ({
                url: `/WorkSchedule/${workScheduleId}/Worker/${workerId}/CheckOut?time=${time}`,
                method: 'POST',
            })
        }),

        ScheduleCheckOut: builder.mutation<any, { workScheduleId: string }>({
            query: ({ workScheduleId }) => ({
                url: `/WorkSchedule/${workScheduleId}/CheckOut`,
                method: 'POST',
            })
        }),
        // getWorkScheduleFile: builder.query<any, string>({
        //     query: (id) => {
        //         return {
        //             url: `/WorkSchedule/file/${id}`,
        //             responseHandler: async (response) => {
        //                 const blob = await response.blob();
        //                 var blobUrl = URL.createObjectURL(blob);
        //                 return { url: blobUrl };
        //             },
        //         }
        //     }
        // }),


        getWorkScheduleFile: builder.query<string, string>({
            query: (id) => ({
                url: '/WorkSchedule/file/'.concat(id),
                responseHandler: (response) =>
                    response.blob().then((blob) => URL.createObjectURL(blob)),
            }),
        }),

        countIn: builder.mutation<any, { workScheduleId: string }>({
            query: ({ workScheduleId }) => ({
                url: `/WorkSchedule/${workScheduleId}/count-in`,
                method: 'POST',
                body: workScheduleId,
            })
        }),

        countOut: builder.mutation<any, { workScheduleId: string }>({
            query: ({ workScheduleId }) => ({
                url: `/WorkSchedule/${workScheduleId}/count-out`,
                method: 'POST',
                body: workScheduleId,
            })
        }),

        countInAI: builder.mutation<any, { workScheduleId: string }>({
            query: ({ workScheduleId }) => ({
                url: `/WorkSchedule/${workScheduleId}/count-in-ai`,
                method: 'POST',
                body: workScheduleId,
            })
        }),

        countOutAI: builder.mutation<any, { workScheduleId: string }>({
            query: ({ workScheduleId }) => ({
                url: `/WorkSchedule/${workScheduleId}/count-out-ai`,
                method: 'POST',
                body: workScheduleId,
            })
        }),

        getRecordingsByScheduleId: builder.query<any, string>({
            query: (workScheduleId) => ({
                url: `/WorkSchedule/${workScheduleId}/recordings`,
            })
        }),

        getRiskAssessmentReport: builder.query<Blob, string>({
            query: (workScheduleId) => ({
                url: `/WorkSchedule/${workScheduleId}/RiskAssessment/Report`,
                responseHandler: async (response) => response.blob(),
            }),
        }),

        getWorkPermitReport: builder.query<Blob, string>({
            query: (workScheduleId) => ({
                url: `/WorkSchedule/${workScheduleId}/WorkPermit/Report`,
                responseHandler: async (response) => response.blob(),
            }),
        }),
    })
})

export const {
    useLazyGetScheduleByScheduleIdQuery,
    useLazyGetScheduleByIdQuery,
    useLazyGetScheduleListingQuery,
    useCreateScheduleMutation,
    useUpdateScheduleMutation,
    useLazyGetTodayScheduleQuery,
    useWorkerCheckInMutation,
    useWorkerCheckOutMutation,
    useLazyGetWorkScheduleFileQuery,
    useScheduleCheckOutMutation,
    useCountInMutation,
    useCountOutMutation,
    useCountInAIMutation,
    useCountOutAIMutation,
    useLazyGetRecordingsByScheduleIdQuery,
    useLazyGetRiskAssessmentReportQuery,
    useLazyGetWorkPermitReportQuery,
} = ScheduleSlice